import { render, staticRenderFns } from "./ManageDocumentTypes.vue?vue&type=template&id=34890b0b&scoped=true"
import script from "./ManageDocumentTypes.vue?vue&type=script&lang=js"
export * from "./ManageDocumentTypes.vue?vue&type=script&lang=js"
import style0 from "./ManageDocumentTypes.vue?vue&type=style&index=0&id=34890b0b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34890b0b",
  null
  
)

export default component.exports